
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ikYV", function(module, exports) {

$parcel$export(module.exports, "PeopleItemWrapper", () => $33f1b170359dc05f$export$d14108b02676542c);

var $gwFzn = parcelRequire("gwFzn");

var $2ksky = parcelRequire("2ksky");

var $luv00 = parcelRequire("luv00");
const $33f1b170359dc05f$export$d14108b02676542c = (props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "app-navigation-people-menu",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2ksky.default), props));
};

});
parcelRegister("2ksky", function(module, exports) {

$parcel$export(module.exports, "default", () => $0634841b177d4e6f$export$2e2bcd8739ae039);
// export main component

var $3drSj = parcelRequire("3drSj");
var $0634841b177d4e6f$export$2e2bcd8739ae039 = (0, $3drSj.default);

});
parcelRegister("3drSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ace2048932849d1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");

var $aJmpt = parcelRequire("aJmpt");

var $lGgRw = parcelRequire("lGgRw");

var $59VYi = parcelRequire("59VYi");

var $01uj3 = parcelRequire("01uj3");

var $bNN1g = parcelRequire("bNN1g");

var $803rE = parcelRequire("803rE");

var $4Cthy = parcelRequire("4Cthy");

var $8n6L2 = parcelRequire("8n6L2");

var $9sCcp = parcelRequire("9sCcp");

var $g6l7i = parcelRequire("g6l7i");

var $eLClK = parcelRequire("eLClK");

var $7Ptsm = parcelRequire("7Ptsm");
// if `@atlaskit/popup` is upgraded from 0.6.x to 1.x,
// we may need to change this to an array of numbers like [0, 12];.
const $4ace2048932849d1$var$OFFSET_FOR_MORE_BUTTON_VIEW = '12px -11px';
const $4ace2048932849d1$var$eventuallyClearHoverMeasure = ()=>{
    setTimeout(()=>{
        (0, $803rE.clearMeasure)('hoverAndClick');
    }, 5 * $4ace2048932849d1$var$SECOND);
};
const $4ace2048932849d1$var$SECOND = 1000;
function $4ace2048932849d1$export$b26ac1e1a63fbe24(props) {
    const { customChevronIcon: customChevronIcon, isHighlighted: isHighlighted, enablePreFetchingByHovering: enablePreFetchingByHovering, createAnalyticsEvent: createAnalyticsEvent, peopleText: peopleText, onClick: onClick = (0, $bNN1g.VOID_FUNC) } = props;
    const [canPrefetch, setCanPrefetch] = (0, $gwFzn.useState)(false);
    const { testId: testId, isPeopleMenuOpen: isPeopleMenuOpen, isSSR: isSSR, cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, togglePeopleMenu: togglePeopleMenu = (0, $bNN1g.VOID_FUNC), shouldRenderToParent: shouldRenderToParent = false } = (0, $gwFzn.useContext)((0, $59VYi.PeopleMenuContext));
    const { isVisible: isVisible } = (0, $aJmpt.useOverflowStatus)();
    const closeMenu = (0, $gwFzn.useCallback)(()=>togglePeopleMenu(false), [
        togglePeopleMenu
    ]);
    const handleClickOnTriggerButton = (0, $gwFzn.useCallback)(()=>{
        onClick(!isPeopleMenuOpen);
        togglePeopleMenu(!isPeopleMenuOpen);
        // measure duration of click and show menu
        (0, $803rE.startMeasure)('clickAndShow');
        (0, $803rE.stopMeasure)('hoverAndClick', (duration, startTime)=>{
            (0, $4Cthy.triggerAnalyticsForHoverAndClick)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isPeopleMenuOpen,
        onClick,
        togglePeopleMenu
    ]);
    const handleMouseEnterTriggerButton = (0, $gwFzn.useCallback)(()=>{
        (0, $8n6L2.MenuContent).preload();
        if (!canPrefetch) {
            setCanPrefetch(true);
            // measure duration time between hovering and clicking
            (0, $803rE.startMeasure)('hoverAndClick');
            // clear all unwanted hovering after 5 seconds
            $4ace2048932849d1$var$eventuallyClearHoverMeasure();
        }
    }, [
        canPrefetch,
        setCanPrefetch
    ]);
    const buttonProps = {
        isSelected: isPeopleMenuOpen,
        onClick: handleClickOnTriggerButton,
        onMouseEnter: handleMouseEnterTriggerButton,
        testId: `${testId}-people-primary-button`,
        peopleText: peopleText
    };
    const PopupContent = (0, $gwFzn.useCallback)(()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $9sCcp.PeopleMenuContentInternal), {}), []);
    if (isSSR) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eLClK.PeopleMenuTriggerSSR), {
        testId: testId,
        peopleText: peopleText
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
                // @ts-ignore
                offset: isVisible ? undefined : $4ace2048932849d1$var$OFFSET_FOR_MORE_BUTTON_VIEW,
                content: PopupContent,
                isOpen: isPeopleMenuOpen,
                placement: isVisible ? 'bottom-start' : 'right-start',
                onClose: closeMenu,
                shouldRenderToParent: shouldRenderToParent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eLClK.default), {
                        isVisible: isVisible,
                        isHighlighted: isHighlighted,
                        customChevronIcon: customChevronIcon,
                        triggerProps: triggerProps,
                        ...buttonProps
                    })
            }),
            enablePreFetchingByHovering && canPrefetch && (0, $01uj3.isCachedDataClear)() && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7Ptsm.UsersTeamsPreFetch), {
                cloudId: cloudId,
                orgId: orgId,
                userId: userId,
                product: product,
                tenantUrl: tenantUrl
            })
        ]
    });
}
const $4ace2048932849d1$var$PeopleMenuInternalWithAnalytics = (0, $1DWH0.default)()($4ace2048932849d1$export$b26ac1e1a63fbe24);
function $4ace2048932849d1$export$2e2bcd8739ae039(props) {
    const { isHighlighted: isHighlighted, onClick: onClick, enablePreFetchingByHovering: enablePreFetchingByHovering, customChevronIcon: customChevronIcon, peopleText: peopleText, ...providerProps } = {
        ...props
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g6l7i.default), {
        ...providerProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($4ace2048932849d1$var$PeopleMenuInternalWithAnalytics, {
            customChevronIcon: customChevronIcon,
            isHighlighted: isHighlighted,
            onClick: onClick,
            enablePreFetchingByHovering: enablePreFetchingByHovering,
            peopleText: peopleText
        })
    });
}

});
parcelRegister("59VYi", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContext", () => $1f69b46fb9008860$export$c92ff8b73313c89);
$parcel$export(module.exports, "PeopleMenuContextProvider", () => $1f69b46fb9008860$export$4e812997de4564ae);
$parcel$export(module.exports, "usePeopleMenuContext", () => $1f69b46fb9008860$export$c8d82c28669da5dc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $aJnVh = parcelRequire("aJnVh");

const $1f69b46fb9008860$var$AKModalTransition = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4kBI2")).then((module)=>({
            default: module.ModalTransition
        })));

const $1f69b46fb9008860$var$TeamCreateDialog = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aLPl5")).then((module)=>({
            default: module.TeamCreateDialog
        })));
// this wrapper is for preventing changing layout of around elements
const $1f69b46fb9008860$var$DialogWrapper = (0, $ecnYn.xcss)({
    width: 'space.0',
    height: 'space.0',
    margin: '0',
    padding: '0',
    '::before': {
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0'
    },
    '::after': {
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0'
    }
});
const $1f69b46fb9008860$var$analyticsAttrsTeamCreateDialog = {
    ref: (0, $aJnVh.AnalyticsSource).PEOPLE_MENU
};
const $1f69b46fb9008860$export$c92ff8b73313c89 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    orgId: '',
    cloudId: '',
    userId: '',
    product: 'confluence',
    testId: '',
    isPeopleMenuOpen: false,
    isSSR: false,
    onClickedItem: ()=>undefined,
    pushRoute: ()=>undefined,
    togglePeopleMenu: ()=>undefined,
    toggleTeamCreateDialog: ()=>undefined,
    _hasError: undefined,
    teamCreateDialogProps: {},
    shouldRenderToParent: false,
    isSectionList: false
});
function $1f69b46fb9008860$export$4e812997de4564ae(props) {
    const { isSSR: isSSR = false } = props;
    const [isOpenTeamCreateDialog, toggleOpenTeamCreateDialog] = (0, $gwFzn.useState)(false);
    const { children: children, isOpen: isOpen, onOpen: onOpen, onClose: onClose, ...otherProps } = props;
    const togglePeopleMenu = (0, $gwFzn.useCallback)((newState)=>{
        if (newState === isOpen) return;
        if (newState) onOpen();
        else onClose();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const toggleTeamCreateDialog = (0, $gwFzn.useCallback)((isOpen)=>{
        toggleOpenTeamCreateDialog(isOpen);
    }, [
        toggleOpenTeamCreateDialog
    ]);
    const values = (0, $gwFzn.useMemo)(()=>({
            teamCreateDialogProps: {},
            ...otherProps,
            // extra props
            isPeopleMenuOpen: isOpen,
            togglePeopleMenu: togglePeopleMenu,
            toggleTeamCreateDialog: toggleTeamCreateDialog
        }), [
        otherProps,
        isOpen,
        togglePeopleMenu,
        toggleTeamCreateDialog
    ]);
    const closeTeamCreateDialog = (0, $gwFzn.useCallback)(()=>{
        toggleOpenTeamCreateDialog(false);
        if (typeof values.teamCreateDialogProps?.onClose === 'function') values.teamCreateDialogProps.onClose();
    }, [
        toggleOpenTeamCreateDialog,
        values.teamCreateDialogProps
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($1f69b46fb9008860$export$c92ff8b73313c89.Provider, {
        value: values,
        children: [
            children,
            !isSSR && isOpenTeamCreateDialog && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $1f69b46fb9008860$var$DialogWrapper,
                testId: `${otherProps.testId}-team-create-dialog-wrapper`,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($1f69b46fb9008860$var$AKModalTransition, {
                        children: isOpenTeamCreateDialog && /*#__PURE__*/ (0, $7UHDa.jsx)($1f69b46fb9008860$var$TeamCreateDialog, {
                            cloudId: values.cloudId,
                            orgId: values.orgId,
                            product: values.product,
                            principalId: values.userId,
                            addFlag: values.addFlag,
                            pushRoute: values.pushRoute,
                            extraAnalyticsAttrs: $1f69b46fb9008860$var$analyticsAttrsTeamCreateDialog,
                            ...values.teamCreateDialogProps,
                            onClose: closeTeamCreateDialog
                        })
                    })
                })
            })
        ]
    });
}
const $1f69b46fb9008860$export$c8d82c28669da5dc = ()=>(0, $gwFzn.useContext)($1f69b46fb9008860$export$c92ff8b73313c89);

});
parcelRegister("aJnVh", function(module, exports) {

$parcel$export(module.exports, "AnalyticsActionSubject", () => $2cd2dabb2293c5cf$export$4bce2c1f3a5d9f61);
$parcel$export(module.exports, "AnalyticsAction", () => $2cd2dabb2293c5cf$export$30c16f5c43437fd7);
$parcel$export(module.exports, "AnalyticsSource", () => $2cd2dabb2293c5cf$export$6890652a1aff7d1c);
var $2cd2dabb2293c5cf$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["VIEW_PEOPLE_ADDITIONAL_LINK"] = "additionalMenuLink";
    AnalyticsActionSubject["VIEW_PEOPLE_DIRECTORY_LINK"] = "viewAllPeopleDirectory";
    AnalyticsActionSubject["CREATE_NEW_TEAM_LINK"] = "createNewTeamLink";
    AnalyticsActionSubject["PEOPLE_MENU_LINK"] = "peopleMenuLink";
    AnalyticsActionSubject["TEAM_MENU_LINK"] = "teamMenuLink";
    AnalyticsActionSubject["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsActionSubject["NAVIGATION_MENU_ITEM"] = "navigationMenuItem";
    AnalyticsActionSubject["PRE_FETCH_DATA"] = "preFetchData";
    AnalyticsActionSubject["FETCHING_USERS_TEAMS_DATA"] = "fetchingUsersTeamsData";
    AnalyticsActionSubject["HOVER_AND_CLICK_PEOPLE_BUTTON"] = "hoverAndClickPeopleButton";
    AnalyticsActionSubject["BUTTON"] = "button";
    return AnalyticsActionSubject;
}({});
var $2cd2dabb2293c5cf$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["EXPOSED"] = "exposed";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["TRIGGERED"] = "triggered";
    AnalyticsAction["MEASURED"] = "measured";
    AnalyticsAction["INELIGIBLE"] = "ineligible";
    return AnalyticsAction;
}({});
var $2cd2dabb2293c5cf$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["PEOPLE_MENU"] = "peopleMenu";
    return AnalyticsSource;
}({});

});

parcelRegister("4kBI2", function(module, exports) {

let $327647f94ec7bf13$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $327647f94ec7bf13$var$load("joJy8"),
    $327647f94ec7bf13$var$load("aHE9G"),
    $327647f94ec7bf13$var$load("bf0yj")
]).then(()=>parcelRequire('3yfJl'));

});

parcelRegister("aLPl5", function(module, exports) {

let $7d761e0d8c34ef75$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7d761e0d8c34ef75$var$load("11tIB"),
    $7d761e0d8c34ef75$var$load("2BIkk"),
    $7d761e0d8c34ef75$var$load("lJxwk"),
    $7d761e0d8c34ef75$var$load("4zTgj"),
    $7d761e0d8c34ef75$var$load("2GYRS"),
    $7d761e0d8c34ef75$var$load("hKqxh"),
    $7d761e0d8c34ef75$var$load("7sseo"),
    $7d761e0d8c34ef75$var$load("ffEVr"),
    $7d761e0d8c34ef75$var$load("c6MKV"),
    $7d761e0d8c34ef75$var$load("aZinD"),
    $7d761e0d8c34ef75$var$load("joJy8"),
    $7d761e0d8c34ef75$var$load("aHE9G"),
    $7d761e0d8c34ef75$var$load("6SYnx")
]).then(()=>parcelRequire('bOcE1'));

});


parcelRegister("01uj3", function(module, exports) {

$parcel$export(module.exports, "isCachedDataClear", () => $9e158893531a2e3e$export$cee8b843259f0f74);
$parcel$export(module.exports, "default", () => $9e158893531a2e3e$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $3xidt = parcelRequire("3xidt");
var $iuGRP = parcelRequire("iuGRP");
const $9e158893531a2e3e$export$50fd3325777ce4bc = new Map();
const $9e158893531a2e3e$export$cd84c175965a58da = 'collaborators';
const $9e158893531a2e3e$export$b5c382592ac689a7 = 'teams';
const $9e158893531a2e3e$var$ONE_SEC = 1000;
const $9e158893531a2e3e$var$ONE_MINUTE = $9e158893531a2e3e$var$ONE_SEC * 60;
const $9e158893531a2e3e$var$REQUEST_CACHE_TIMEOUT_TEAMS = $9e158893531a2e3e$var$ONE_MINUTE;
const $9e158893531a2e3e$var$REQUEST_CACHE_TIMEOUT_USERS = $9e158893531a2e3e$var$ONE_MINUTE * 5;
function $9e158893531a2e3e$export$cee8b843259f0f74() {
    return $9e158893531a2e3e$export$50fd3325777ce4bc.size === 0;
}
function $9e158893531a2e3e$export$2e2bcd8739ae039(cloudId, userId, product, tenantUrl, requestCacheTimeout, orgId) {
    const [dataUsers, setDataUsers] = (0, $gwFzn.useState)(undefined);
    const [dataTeams, setDataTeams] = (0, $gwFzn.useState)(undefined);
    const { loading: isLoadingUsers, error: errorUsers, data: users } = (0, $3xidt.useCollaboratorsService)(cloudId, 'context', tenantUrl, requestCacheTimeout === undefined ? $9e158893531a2e3e$var$REQUEST_CACHE_TIMEOUT_USERS : requestCacheTimeout);
    const { loading: isLoadingTeams, error: errorTeams, data: teams } = (0, $iuGRP.useTeamsOfService)(userId, cloudId, product, tenantUrl, requestCacheTimeout === undefined ? $9e158893531a2e3e$var$REQUEST_CACHE_TIMEOUT_TEAMS : requestCacheTimeout, orgId);
    // after the service return the latest data,
    // we store users data in cache store.
    (0, $gwFzn.useEffect)(()=>{
        if (!users || isLoadingUsers || errorUsers) return;
        $9e158893531a2e3e$export$50fd3325777ce4bc.set($9e158893531a2e3e$export$cd84c175965a58da, users);
        setDataUsers(users);
    }, [
        users,
        isLoadingUsers,
        errorUsers
    ]);
    // after the service return the latest data,
    // store teams data in cache store.
    (0, $gwFzn.useEffect)(()=>{
        if (!teams || isLoadingTeams || errorTeams) return;
        $9e158893531a2e3e$export$50fd3325777ce4bc.set($9e158893531a2e3e$export$b5c382592ac689a7, teams);
        setDataTeams(teams);
    }, [
        teams,
        isLoadingTeams,
        errorTeams
    ]);
    return {
        users: dataUsers && dataUsers.length ? dataUsers : $9e158893531a2e3e$export$50fd3325777ce4bc.get($9e158893531a2e3e$export$cd84c175965a58da),
        teams: dataTeams && dataTeams.length ? dataTeams : $9e158893531a2e3e$export$50fd3325777ce4bc.get($9e158893531a2e3e$export$b5c382592ac689a7),
        errorTeams: errorTeams,
        errorUsers: errorUsers,
        isLoading: isLoadingUsers || isLoadingTeams
    };
}

});
parcelRegister("3xidt", function(module, exports) {

$parcel$export(module.exports, "useCollaboratorsService", () => $9704413bb62e01df$export$979a4f9449b8be53);

var $gwFzn = parcelRequire("gwFzn");

var $6cLw9 = parcelRequire("6cLw9");

var $iyA6F = parcelRequire("iyA6F");

var $eNpV2 = parcelRequire("eNpV2");

var $1y96J = parcelRequire("1y96J");
const $9704413bb62e01df$var$mapFetchCollaboratorsFnByTimeout = new Map();
function $9704413bb62e01df$var$getFetchCollaboratorsCachedFn(timeout = (0, $eNpV2.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $9704413bb62e01df$var$mapFetchCollaboratorsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $eNpV2.withCached)((0, $6cLw9.fetchCollaborators), timeout);
    $9704413bb62e01df$var$mapFetchCollaboratorsFnByTimeout.set(timeout, fn);
    return fn;
}
function $9704413bb62e01df$export$979a4f9449b8be53(cloudId, userId = 'context', tenantUrl = '', cacheTimeout) {
    const request = (0, $gwFzn.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $9704413bb62e01df$var$getFetchCollaboratorsCachedFn(cacheTimeout);
            return fn(cloudId, userId, tenantUrl);
        }
        return (0, $6cLw9.fetchCollaborators)(cloudId, userId, tenantUrl);
    }, [
        cacheTimeout,
        cloudId,
        userId,
        tenantUrl
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $1y96J.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $gwFzn.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $gwFzn.useMemo)(()=>(0, $iyA6F.transformCollabsDataToUsers)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("6cLw9", function(module, exports) {

$parcel$export(module.exports, "fetchCollaborators", () => $92b4e08300e0053e$export$cadad85c3acf2ad8);

var $dAQwn = parcelRequire("dAQwn");
const $92b4e08300e0053e$export$42623aff9edf525f = '/gateway/api/collaboration/v1/collaborationgraph/user/user';
const $92b4e08300e0053e$var$LIMIT_RESULTS = 5;
const $92b4e08300e0053e$export$cadad85c3acf2ad8 = (cloudId, userId = 'context', tenantUrl = '')=>(0, $dAQwn.postJson)(`${tenantUrl}${$92b4e08300e0053e$export$42623aff9edf525f}`, {
        context: {
            contextType: 'atlassianPeoplePackage',
            principalId: userId,
            siteId: cloudId
        },
        maxNumberOfResults: $92b4e08300e0053e$var$LIMIT_RESULTS,
        userId: userId,
        expanded: true
    });

});

parcelRegister("iyA6F", function(module, exports) {

$parcel$export(module.exports, "transformCollabsDataToUsers", () => $87d65caa4c072e21$export$1eb7590d078520b8);

var $1nWX3 = parcelRequire("1nWX3");
const $87d65caa4c072e21$var$userMapper = (user)=>{
    const { userProfile: userProfile, entityType: entityType } = user;
    if (!userProfile || entityType !== (0, $1nWX3.ENTITY_TYPE).USER) return null;
    return {
        id: user.id,
        fullName: userProfile.name,
        nickname: userProfile.nickname,
        email: userProfile.email,
        avatarUrl: userProfile.picture,
        collaborationGraphScore: user.score,
        status: userProfile.account_status
    };
};
const $87d65caa4c072e21$export$1eb7590d078520b8 = (data)=>{
    if (!data) return [];
    const { collaborationGraphEntities: collaborationGraphEntities = [] } = data;
    return collaborationGraphEntities.map($87d65caa4c072e21$var$userMapper).filter((item)=>item) || [];
};

});
parcelRegister("1nWX3", function(module, exports) {

$parcel$export(module.exports, "ENTITY_TYPE", () => $c045c2199421f96f$export$49be827a0aef75dd);
var $c045c2199421f96f$export$49be827a0aef75dd = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}({});
var $c045c2199421f96f$export$fba7c3adda5094d9 = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}({});

});


parcelRegister("eNpV2", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY", () => $1f773b3e27001fb5$export$d8b1aa62ff4847fc);
$parcel$export(module.exports, "withCached", () => $1f773b3e27001fb5$export$7f51828d6b6af163);
const $1f773b3e27001fb5$var$ONE_SECOND = 1000;
const $1f773b3e27001fb5$export$d8b1aa62ff4847fc = 5 * $1f773b3e27001fb5$var$ONE_SECOND;
const $1f773b3e27001fb5$var$isPromise = (p)=>{
    return p !== undefined && typeof p.then === 'function' && typeof p.catch === 'function';
};
const $1f773b3e27001fb5$export$7f51828d6b6af163 = (fn, timeout = $1f773b3e27001fb5$export$d8b1aa62ff4847fc)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        // we don't handle non-promise data so skip it
        if ($1f773b3e27001fb5$var$isPromise(maybePromise)) {
            promiseCache.set(cacheKey, maybePromise);
            maybePromise.then((result)=>{
                resultCache.set(cacheKey, result);
                setTimeout(()=>{
                    promiseCache.delete(cacheKey);
                    resultCache.delete(cacheKey);
                }, timeout);
            }).catch(()=>{
                promiseCache.delete(cacheKey);
                resultCache.delete(cacheKey);
            });
        }
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});


parcelRegister("iuGRP", function(module, exports) {

$parcel$export(module.exports, "useTeamsOfService", () => $c03b75352042644d$export$668750a034956301);

var $gwFzn = parcelRequire("gwFzn");

var $2z5wT = parcelRequire("2z5wT");

var $8WLH9 = parcelRequire("8WLH9");

var $eNpV2 = parcelRequire("eNpV2");

var $1y96J = parcelRequire("1y96J");
const $c03b75352042644d$var$mapFetchMyTeamsFnByTimeout = new Map();
function $c03b75352042644d$var$getFetchMyTeamsCachedFn(timeout = (0, $eNpV2.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $c03b75352042644d$var$mapFetchMyTeamsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $eNpV2.withCached)((0, $2z5wT.searchTeamsOfUser), timeout);
    $c03b75352042644d$var$mapFetchMyTeamsFnByTimeout.set(timeout, fn);
    return fn;
}
function $c03b75352042644d$export$668750a034956301(userId, cloudId, product, tenantUrl = '', cacheTimeout, orgId) {
    const request = (0, $gwFzn.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $c03b75352042644d$var$getFetchMyTeamsCachedFn(cacheTimeout);
            return fn(userId, cloudId, product, tenantUrl, orgId);
        }
        return (0, $2z5wT.searchTeamsOfUser)(userId, cloudId, product, tenantUrl, orgId);
    }, [
        cacheTimeout,
        userId,
        cloudId,
        product,
        tenantUrl,
        orgId
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $1y96J.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $gwFzn.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $gwFzn.useMemo)(()=>(0, $8WLH9.transformTeams)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});


parcelRegister("bNN1g", function(module, exports) {

$parcel$export(module.exports, "VOID_FUNC", () => $f8ab4ca1f8c7752f$export$7e6ba5d480e9bd2f);
const $f8ab4ca1f8c7752f$export$53bb833296af4a30 = 5;
const $f8ab4ca1f8c7752f$export$88d6945644578407 = 3;
const $f8ab4ca1f8c7752f$export$7e6ba5d480e9bd2f = ()=>undefined;

});

parcelRegister("803rE", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $4c4d7ef83a7140c7$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $4c4d7ef83a7140c7$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $4c4d7ef83a7140c7$export$6f766653554dac02);
const $4c4d7ef83a7140c7$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $4c4d7ef83a7140c7$var$hasPerformanceAPIAvailable = $4c4d7ef83a7140c7$var$isPerformanceAPIAvailable();
const $4c4d7ef83a7140c7$var$measureMap = new Map();
function $4c4d7ef83a7140c7$export$b62aa2130c86b59b(measureName) {
    if (!$4c4d7ef83a7140c7$var$hasPerformanceAPIAvailable) return;
    performance.mark(`${measureName}::start`);
    $4c4d7ef83a7140c7$var$measureMap.set(measureName, performance.now());
}
function $4c4d7ef83a7140c7$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!$4c4d7ef83a7140c7$var$hasPerformanceAPIAvailable) return;
    // `startMeasure` is not called with `measureName` before.
    if (!$4c4d7ef83a7140c7$var$measureMap.get(measureName)) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $4c4d7ef83a7140c7$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $4c4d7ef83a7140c7$export$6f766653554dac02(measureName);
    }
}
function $4c4d7ef83a7140c7$export$6f766653554dac02(measureName) {
    if (!$4c4d7ef83a7140c7$var$hasPerformanceAPIAvailable) return;
    $4c4d7ef83a7140c7$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("4Cthy", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForClickCreateNewTeam", () => $5eecc8a0c8d2ea0b$export$c22050996e7c2c8a);
$parcel$export(module.exports, "triggerAnalyticsForMenuLink", () => $5eecc8a0c8d2ea0b$export$e2de484c93cb7dd8);
$parcel$export(module.exports, "triggerAnalyticsForClickViewDirectory", () => $5eecc8a0c8d2ea0b$export$e3be20a27c367b1d);
$parcel$export(module.exports, "triggerAnalyticsForClickInvitePeople", () => $5eecc8a0c8d2ea0b$export$bb6086ba6d61c34e);
$parcel$export(module.exports, "triggerAnalyticsForClickOnPeople", () => $5eecc8a0c8d2ea0b$export$8c5588f22f5cd9d8);
$parcel$export(module.exports, "triggerAnalyticsForClickOnTeam", () => $5eecc8a0c8d2ea0b$export$580e4977bd9f636d);
$parcel$export(module.exports, "triggerAnalyticsForViewedPeopleMenu", () => $5eecc8a0c8d2ea0b$export$b7b4061d9dd52eb9);
$parcel$export(module.exports, "triggerAnalyticsForRenderedInvitePeople", () => $5eecc8a0c8d2ea0b$export$3e9b11df8135b7cb);
$parcel$export(module.exports, "triggerAnalyticsForPreFetchData", () => $5eecc8a0c8d2ea0b$export$750c07c02477d2f7);
$parcel$export(module.exports, "triggerAnalyticsForLoadingIndicator", () => $5eecc8a0c8d2ea0b$export$d88a623841ba7b50);
$parcel$export(module.exports, "triggerAnalyticsForFetchingData", () => $5eecc8a0c8d2ea0b$export$bda81aea2199d550);
$parcel$export(module.exports, "triggerAnalyticsForHoverAndClick", () => $5eecc8a0c8d2ea0b$export$f2cf5fec906275c6);
$parcel$export(module.exports, "triggerAnalyticsForViewedFullUsersAndTeams", () => $5eecc8a0c8d2ea0b$export$589011fd49e3f6d6);
$parcel$export(module.exports, "triggerAnalyticsForNoBrowsePeoplePermission", () => $5eecc8a0c8d2ea0b$export$1eb2f70fed6b75f7);
$parcel$export(module.exports, "AnalyticsActionSubject", () => (parcelRequire("aJnVh")).AnalyticsActionSubject);
$parcel$export(module.exports, "AnalyticsAction", () => (parcelRequire("aJnVh")).AnalyticsAction);

var $cpl2G = parcelRequire("cpl2G");

var $aJnVh = parcelRequire("aJnVh");

var $gASgv = parcelRequire("gASgv");
const $5eecc8a0c8d2ea0b$export$c22050996e7c2c8a = (createAnalyticsEvent)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).CREATE_NEW_TEAM_LINK,
        action: (0, $aJnVh.AnalyticsAction).CLICKED
    });
};
const $5eecc8a0c8d2ea0b$export$e2de484c93cb7dd8 = (additionalLinkId, action, createAnalyticsEvent, attributes)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).VIEW_PEOPLE_ADDITIONAL_LINK,
        actionSubjectId: additionalLinkId,
        action: action,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $5eecc8a0c8d2ea0b$export$e3be20a27c367b1d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).VIEW_PEOPLE_DIRECTORY_LINK,
        action: (0, $aJnVh.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $5eecc8a0c8d2ea0b$export$bb6086ba6d61c34e = (createAnalyticsEvent, attributes)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).NAVIGATION_MENU_ITEM,
        actionSubjectId: 'addPeopleNavigationMenuItem',
        action: (0, $aJnVh.AnalyticsAction).CLICKED,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $5eecc8a0c8d2ea0b$export$8c5588f22f5cd9d8 = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: (0, $aJnVh.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $5eecc8a0c8d2ea0b$export$580e4977bd9f636d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: (0, $aJnVh.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $5eecc8a0c8d2ea0b$export$b7b4061d9dd52eb9 = (createAnalyticsEvent, isCacheEmpty = false)=>{
    (0, $cpl2G.fireScreenEvent)(createAnalyticsEvent, {
        name: 'peopleMenu',
        attributes: {
            isCacheEmpty: isCacheEmpty
        }
    });
};
const $5eecc8a0c8d2ea0b$export$3e9b11df8135b7cb = (createAnalyticsEvent)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: 'addPeopleNavigationItem',
        action: (0, $aJnVh.AnalyticsAction).RENDERED
    });
};
const $5eecc8a0c8d2ea0b$export$750c07c02477d2f7 = (createAnalyticsEvent)=>{
    (0, $cpl2G.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).PRE_FETCH_DATA,
        action: (0, $aJnVh.AnalyticsAction).TRIGGERED
    });
};
const $5eecc8a0c8d2ea0b$export$d88a623841ba7b50 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).PEOPLE_MENU,
        actionSubjectId: 'loadingIndicator',
        action: (0, $aJnVh.AnalyticsAction).VIEWED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $5eecc8a0c8d2ea0b$export$bda81aea2199d550 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $cpl2G.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).FETCHING_USERS_TEAMS_DATA,
        action: (0, $aJnVh.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $5eecc8a0c8d2ea0b$export$f2cf5fec906275c6 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $cpl2G.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).HOVER_AND_CLICK_PEOPLE_BUTTON,
        action: (0, $aJnVh.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $5eecc8a0c8d2ea0b$export$589011fd49e3f6d6 = (createAnalyticsEvent, usersCount = 0, teamsCount = 0, duration = 0, startTime = 0)=>{
    (0, $cpl2G.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $aJnVh.AnalyticsAction).SUCCEEDED,
        attributes: {
            usersCount: usersCount,
            teamsCount: teamsCount,
            duration: duration,
            startTime: startTime
        }
    });
};
const $5eecc8a0c8d2ea0b$export$1eb2f70fed6b75f7 = (createAnalyticsEvent)=>{
    (0, $cpl2G.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $aJnVh.AnalyticsAction).VIEWED,
        actionSubjectId: 'noBrowsePermission'
    });
};

});
parcelRegister("gASgv", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForLoadedPeople", () => $faaf189eb916cf76$export$62ecc9342d32a444);
$parcel$export(module.exports, "triggerAnalyticsForLoadedTeam", () => $faaf189eb916cf76$export$e648838c8bbef986);

var $cpl2G = parcelRequire("cpl2G");
parcelRequire("4Cthy");
var $aJnVh = parcelRequire("aJnVh");
const $faaf189eb916cf76$export$62ecc9342d32a444 = (action, createAnalyticsEvent, status, error)=>{
    (0, $cpl2G.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: action === 'succeeded' ? (0, $aJnVh.AnalyticsAction).SUCCEEDED : (0, $aJnVh.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};
const $faaf189eb916cf76$export$e648838c8bbef986 = (action, createAnalyticsEvent, status, error)=>{
    (0, $cpl2G.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aJnVh.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: action === 'succeeded' ? (0, $aJnVh.AnalyticsAction).SUCCEEDED : (0, $aJnVh.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};

});


parcelRegister("8n6L2", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $25f786067390d577$export$479f0f2f71193efe);
$parcel$export(module.exports, "MenuContentFallback", () => $25f786067390d577$export$48b47052ec2aea7f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $63PsS = parcelRequire("63PsS");

var $2SlZp = parcelRequire("2SlZp");

var $59VYi = parcelRequire("59VYi");

var $01uj3 = parcelRequire("01uj3");

var $4oqeB = parcelRequire("4oqeB");

var $h9eXX = parcelRequire("h9eXX");

const $25f786067390d577$export$479f0f2f71193efe = (0, $63PsS.lazyForPaint)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("4pN0R")));
const $25f786067390d577$export$b0396be60c0e9152 = 480;
const $25f786067390d577$export$3f133812f81dfa49 = 320;
const $25f786067390d577$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $25f786067390d577$export$48b47052ec2aea7f() {
    const { cloudId: cloudId, tenantUrl: tenantUrl, userId: userId, product: product, testId: testId, orgId: orgId } = (0, $gwFzn.useContext)((0, $59VYi.PeopleMenuContext));
    // kick off some requests sooner
    (0, $01uj3.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2SlZp.default), {
        testId: `${testId}-group-loading`,
        maxWidth: $25f786067390d577$export$b0396be60c0e9152,
        maxHeight: $25f786067390d577$export$94aaf6acd960c412,
        minWidth: $25f786067390d577$export$3f133812f81dfa49,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4oqeB.MenuGroupPeople), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h9eXX.MenuGroupTeams), {
                isLoading: true
            })
        ]
    });
}

});
parcelRegister("4oqeB", function(module, exports) {

$parcel$export(module.exports, "MenuGroupPeople", () => $28b9dfa2b9461366$export$c521b8e86241ef89);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1DWH0 = parcelRequire("1DWH0");

var $cGtPE = parcelRequire("cGtPE");

var $2iK1S = parcelRequire("2iK1S");

var $erMpQ = parcelRequire("erMpQ");

var $59VYi = parcelRequire("59VYi");

var $bNN1g = parcelRequire("bNN1g");

var $8IYsm = parcelRequire("8IYsm");
parcelRequire("4Cthy");
var $aJnVh = parcelRequire("aJnVh");
var $4Cthy = parcelRequire("4Cthy");

var $bkCrK = parcelRequire("bkCrK");

var $aWYZE = parcelRequire("aWYZE");

var $6eoPX = parcelRequire("6eoPX");
const $28b9dfa2b9461366$export$2e63129145f0c868 = (props)=>{
    const intl = (0, $dBxQj.default)();
    const { users: users = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $bNN1g.VOID_FUNC), pushRoute: pushRoute = (0, $bNN1g.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $bNN1g.VOID_FUNC) } = (0, $gwFzn.useContext)((0, $59VYi.PeopleMenuContext));
    const handleClickOnPeople = (0, $gwFzn.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $8IYsm.isModifiedEvent)(event);
            (0, $4Cthy.triggerAnalyticsForClickOnPeople)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'people', event);
            if (isLeftClick) {
                const peopleProfilePage = (0, $erMpQ.getPeopleProfilePage)(remoteConfig.resources, id, product, (0, $aJnVh.AnalyticsActionSubject).PEOPLE_MENU);
                pushRoute(peopleProfilePage);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.collaborators.enabled) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aWYZE.MenuGroupSection), {
        title: remoteConfig.sections.collaborators.label ?? intl.formatMessage((0, $bkCrK.messages).yourCollab),
        testId: `${testId}-people-section`,
        isLoading: isLoading,
        isEmpty: users.length === 0,
        sectionType: 'user',
        maxItems: remoteConfig.sections.collaborators.maxItems,
        children: users.slice(0, remoteConfig.sections.collaborators.maxItems).map((user)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGtPE.default), {
                iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6eoPX.ImgIcon), {
                    src: user.avatarUrl,
                    alt: ""
                }),
                testId: `${testId}-people-item`,
                href: (0, $erMpQ.getPeopleProfilePage)(remoteConfig.resources, user.id, product, (0, $aJnVh.AnalyticsActionSubject).PEOPLE_MENU),
                onClick: handleClickOnPeople(user.id),
                children: user.fullName
            }, user.id))
    });
};
const $28b9dfa2b9461366$export$c521b8e86241ef89 = (0, $1DWH0.default)()((0, $2iK1S.withMandatoryPeopleMenuConfiguration)($28b9dfa2b9461366$export$2e63129145f0c868));

});
parcelRegister("8IYsm", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $6398b2f72737bfe2$export$642c6f14f6d4bbd5);
const $6398b2f72737bfe2$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("bkCrK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e7b6acb0799aa72c$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $e7b6acb0799aa72c$var$PREFIX = 'ptc.pm';
const $e7b6acb0799aa72c$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    yourCollab: {
        id: "ptc.pm.collaborators.title",
        defaultMessage: "Your Collaborators"
    },
    yourTeams: {
        id: "ptc.pm.your-teams.title",
        defaultMessage: "Your Teams"
    },
    viewYourProfile: {
        id: "ptc.pm.view-your-profile",
        defaultMessage: "View your profile"
    },
    errorHeading: {
        id: "ptc.pm.error-heading",
        defaultMessage: "Something\u2019s gone wrong"
    },
    errorText: {
        id: "ptc.pm.error-text",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things"
    },
    errorImageAltText: {
        id: "ptc.pm.error-image-alt-text",
        defaultMessage: "A broken robot and a number of people busy fixing it."
    },
    people: {
        id: "ptc.pm.people",
        defaultMessage: "People"
    },
    teams: {
        id: "ptc.pm.teams",
        defaultMessage: "Teams"
    },
    numMembers: {
        id: "ptc.pm.num-members",
        defaultMessage: "{memberCount, plural, one {# member} other {# members} }"
    }
});

});

parcelRegister("aWYZE", function(module, exports) {

$parcel$export(module.exports, "MenuGroupSection", () => $bac36413da990814$export$33b4adfb29dd0d95);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7rvPL = parcelRequire("7rvPL");
var $3MKHu = parcelRequire("3MKHu");

var $59VYi = parcelRequire("59VYi");

var $iIHlp = parcelRequire("iIHlp");
const $bac36413da990814$export$33b4adfb29dd0d95 = ({ title: title, isEmpty: isEmpty, isLoading: isLoading, children: children, testId: testId, maxItems: maxItems, sectionType: sectionType })=>{
    const { isSectionList: isSectionList = false } = (0, $gwFzn.useContext)((0, $59VYi.PeopleMenuContext));
    if (!isLoading && isEmpty) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7rvPL.default), {
        // title is undefined if we are loading as we show the heading skeleton below
        title: isLoading ? undefined : title,
        testId: testId,
        isList: isSectionList,
        children: isLoading ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3MKHu.default), {
                    testId: `${sectionType}-skeleton-heading`
                }),
                Array(maxItems).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iIHlp.default), {}, `${sectionType}-${index}`))
            ]
        }) : children
    });
};

});
parcelRegister("iIHlp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f56134854ab5d910$export$2e2bcd8739ae039);
/* LoadingSkeletonItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $cQDYl = parcelRequire("cQDYl");
const $f56134854ab5d910$var$styles = {
    skeletonItem: "_mf8oze3t _7x0autpp _1xp3zwfg _da2vzwfg"
};
function $f56134854ab5d910$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $f56134854ab5d910$var$styles.skeletonItem
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cQDYl.default), {
            hasAvatar: true,
            testId: "people-menu-skeleton-item"
        })
    });
}

});


parcelRegister("6eoPX", function(module, exports) {

$parcel$export(module.exports, "MAX_POPUP_WIDTH", () => $cd62dd6077f69147$export$b0396be60c0e9152);
$parcel$export(module.exports, "MIN_POPUP_WIDTH", () => $cd62dd6077f69147$export$3f133812f81dfa49);
$parcel$export(module.exports, "MAX_POPUP_HEIGHT", () => $cd62dd6077f69147$export$94aaf6acd960c412);
$parcel$export(module.exports, "ImgIcon", () => $cd62dd6077f69147$export$804b6389edcac2c2);
$parcel$export(module.exports, "Buggy", () => $cd62dd6077f69147$export$6b52db8960fbef38);
$parcel$export(module.exports, "fireRenderPeopleNavMenuFail", () => $cd62dd6077f69147$export$5884f4bd467a603a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $alaek = parcelRequire("alaek");

var $3PCpU = parcelRequire("3PCpU");

var $48JIW = parcelRequire("48JIW");
const $cd62dd6077f69147$export$91a15f1424900d33 = 32;
const $cd62dd6077f69147$export$b0396be60c0e9152 = 480;
const $cd62dd6077f69147$export$3f133812f81dfa49 = 320;
const $cd62dd6077f69147$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $cd62dd6077f69147$export$804b6389edcac2c2({ src: src, alt: alt }) {
    if ((0, $dh538.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $alaek.default), {
        size: "medium",
        src: src
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        src: src || '',
        alt: alt,
        height: $cd62dd6077f69147$export$91a15f1424900d33,
        width: $cd62dd6077f69147$export$91a15f1424900d33,
        style: {
            borderRadius: $cd62dd6077f69147$export$91a15f1424900d33 / 2
        }
    });
}
function $cd62dd6077f69147$export$6b52db8960fbef38() {
    (0, $gwFzn.useEffect)(()=>{
        throw new Error('Something wrong inside People menu.');
    });
    return null;
}
const $cd62dd6077f69147$export$5884f4bd467a603a = (error)=>{
    (0, $48JIW.renderPeopleNavMenuExp).failure({
        metadata: {
            ...error && 'status' in error ? {
                status: error.status
            } : {},
            ...error instanceof (0, $3PCpU.ErrorWithContext) ? {
                context: error.context
            } : {},
            error: error?.message
        }
    });
};

});
parcelRegister("48JIW", function(module, exports) {

$parcel$export(module.exports, "renderPeopleNavMenuExp", () => $ad0e79e07f98bc35$export$a0db9187c809008d);

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");

var $4USyt = parcelRequire("4USyt");
class $ad0e79e07f98bc35$var$UFOExperienceWithPackageContext extends (0, $5aVN7.UFOExperience) {
    async success() {
        return super.success({
            metadata: {
                ...(0, $4USyt.packageContext)
            }
        });
    }
    async failure(config) {
        return super.failure({
            force: config?.force,
            metadata: {
                ...config?.metadata ?? {},
                ...(0, $4USyt.packageContext)
            }
        });
    }
    async abort() {
        return super.abort({
            metadata: {
                ...(0, $4USyt.packageContext)
            }
        });
    }
}
const $ad0e79e07f98bc35$export$a0db9187c809008d = new $ad0e79e07f98bc35$var$UFOExperienceWithPackageContext('render-people-nav-menu', {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("4USyt", function(module, exports) {

$parcel$export(module.exports, "packageContext", () => $ed0a5919a8f471ed$export$beac86d91b8e8b21);
const $ed0a5919a8f471ed$export$beac86d91b8e8b21 = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});




parcelRegister("h9eXX", function(module, exports) {

$parcel$export(module.exports, "MenuGroupTeams", () => $19f6b2e95d65b92f$export$c3915c5ac3f99d49);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1DWH0 = parcelRequire("1DWH0");

var $cGtPE = parcelRequire("cGtPE");

var $2iK1S = parcelRequire("2iK1S");

var $erMpQ = parcelRequire("erMpQ");

var $59VYi = parcelRequire("59VYi");

var $bNN1g = parcelRequire("bNN1g");

var $8IYsm = parcelRequire("8IYsm");
parcelRequire("4Cthy");
var $aJnVh = parcelRequire("aJnVh");
var $4Cthy = parcelRequire("4Cthy");

var $bkCrK = parcelRequire("bkCrK");

var $aWYZE = parcelRequire("aWYZE");

var $6eoPX = parcelRequire("6eoPX");
const $19f6b2e95d65b92f$export$86c994b04df922e = (props)=>{
    const intl = (0, $dBxQj.default)();
    const { orgId: orgId } = (0, $59VYi.usePeopleMenuContext)();
    const { teams: teams = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $bNN1g.VOID_FUNC), pushRoute: pushRoute = (0, $bNN1g.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $bNN1g.VOID_FUNC) } = (0, $gwFzn.useContext)((0, $59VYi.PeopleMenuContext));
    const handleClickOnTeam = (0, $gwFzn.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $8IYsm.isModifiedEvent)(event);
            (0, $4Cthy.triggerAnalyticsForClickOnTeam)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'team', event);
            if (isLeftClick) {
                const teamUrl = (0, $erMpQ.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: id,
                    orgId: orgId,
                    ref: product,
                    src: (0, $aJnVh.AnalyticsActionSubject).PEOPLE_MENU
                });
                pushRoute(teamUrl);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        orgId,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.teams.enabled) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aWYZE.MenuGroupSection), {
        title: remoteConfig.sections.teams.label ?? intl.formatMessage((0, $bkCrK.messages).yourTeams),
        testId: `${testId}-teams-section`,
        isLoading: isLoading,
        isEmpty: teams.length === 0,
        sectionType: 'team',
        maxItems: remoteConfig.sections.teams.maxItems,
        children: teams.slice(0, remoteConfig.sections.teams.maxItems).map((team)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGtPE.default), {
                href: (0, $erMpQ.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: team.id,
                    orgId: orgId
                }),
                onClick: handleClickOnTeam(team.id),
                iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6eoPX.ImgIcon), {
                    src: team.smallAvatarImageUrl || team.smallHeaderImageUrl,
                    alt: team.displayName
                }),
                description: intl.formatMessage((0, $bkCrK.messages).numMembers, {
                    memberCount: team.memberCount ?? 1
                }),
                testId: `${testId}-team-item`,
                children: team.displayName
            }, team.id))
    });
};
const $19f6b2e95d65b92f$export$c3915c5ac3f99d49 = (0, $1DWH0.default)()((0, $2iK1S.withMandatoryPeopleMenuConfiguration)($19f6b2e95d65b92f$export$86c994b04df922e));

});

parcelRegister("4pN0R", function(module, exports) {

let $336f842bb9db7c21$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $336f842bb9db7c21$var$load("h3VCR"),
    $336f842bb9db7c21$var$load("c6MKV"),
    $336f842bb9db7c21$var$load("ffEVr"),
    $336f842bb9db7c21$var$load("40B2u")
]).then(()=>parcelRequire('5N7x2'));

});


parcelRegister("9sCcp", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContentInternal", () => $73221d145ad21b78$export$78306a734b6419e6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $63PsS = parcelRequire("63PsS");

var $59VYi = parcelRequire("59VYi");

var $k1Dl0 = parcelRequire("k1Dl0");

var $bNN1g = parcelRequire("bNN1g");

var $8n6L2 = parcelRequire("8n6L2");

var $g6l7i = parcelRequire("g6l7i");
const $73221d145ad21b78$var$stopPropagation = (e)=>e.stopPropagation();
const $73221d145ad21b78$export$78306a734b6419e6 = /*#__PURE__*/ (0, $gwFzn.memo)(()=>{
    const { isBrowseUsersEnabled: isBrowseUsersEnabled } = (0, $gwFzn.useContext)((0, $59VYi.PeopleMenuContext));
    const { loading: isLoadingPermission, hasPermission: hasPermission } = (0, $k1Dl0.default)(isBrowseUsersEnabled);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        onClick: $73221d145ad21b78$var$stopPropagation,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $63PsS.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8n6L2.MenuContentFallback), {}),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8n6L2.MenuContent), {
                isLoadingPermission: isLoadingPermission,
                hasPermission: hasPermission
            })
        })
    }));
});
const $73221d145ad21b78$var$PeopleMenuContent = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g6l7i.default), {
        isOpen: true,
        onOpen: (0, $bNN1g.VOID_FUNC),
        onClose: (0, $bNN1g.VOID_FUNC),
        ...props,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($73221d145ad21b78$export$78306a734b6419e6, {})
    });
};
var $73221d145ad21b78$export$2e2bcd8739ae039 = $73221d145ad21b78$var$PeopleMenuContent;

});
parcelRegister("k1Dl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4891a45ba51e5b8b$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $4891a45ba51e5b8b$export$2e2bcd8739ae039(permissionPromise) {
    const noQuery = !permissionPromise;
    const [hasPermission, setPermission] = (0, $gwFzn.useState)(noQuery);
    const [loading, setLoading] = (0, $gwFzn.useState)(!noQuery);
    (0, $gwFzn.useEffect)(()=>{
        if (permissionPromise) permissionPromise().then((permissionResult)=>{
            setPermission(permissionResult);
            setLoading(false);
        }).catch(()=>{
            setPermission(false);
            setLoading(false);
        });
    }, [
        permissionPromise,
        setLoading,
        setPermission
    ]);
    return {
        loading: loading,
        hasPermission: hasPermission
    };
}

});

parcelRegister("g6l7i", function(module, exports) {

$parcel$export(module.exports, "default", () => $987acf99088cba60$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bYRk6 = parcelRequire("bYRk6");

var $iMEBP = parcelRequire("iMEBP");

var $erMpQ = parcelRequire("erMpQ");

var $59VYi = parcelRequire("59VYi");

var $4USyt = parcelRequire("4USyt");

var $aJnVh = parcelRequire("aJnVh");

var $2mhmh = parcelRequire("2mhmh");
const $987acf99088cba60$var$defaultProps = {
    onClickedMenuLink: ()=>Promise.reject('No handler defined. Using default props value.'),
    testId: 'menu',
    isSSR: false
};
/**
 * There are some essential higher components wrapping an actual PeopleMenu component:
 * - PeopleMenuContext: is used to avoid passing common props like cloudId
 * - IntlProvider: to make i18n working
 * - AnalyticsContext: is used to avoid passing many props for triggering analytics events
 * - ErrorBoundary: to capture any errors inside actual PeopleMenu component
 */ const $987acf99088cba60$var$PeopleMenuProviders = (props)=>{
    const { children: children, product: product, subProduct: subProduct, cloudId: cloudId, orgId: orgId, userId: userId, isBrowseUsersEnabled: isBrowseUsersEnabled, testId: testId, tenantUrl: tenantUrl, onClickedItem: onClickedItem, onClickedMenuLink: onClickedMenuLink, invitePeopleHandlers: invitePeopleHandlers, onOpen: onOpen, onClose: onClose, pushRoute: pushRoute, _hasError: _hasError, addFlag: addFlag, isOpen: isOpen, isSSR: isSSR, teamCreateDialogProps: teamCreateDialogProps, shouldRenderToParent: shouldRenderToParent, isSectionList: isSectionList } = {
        ...$987acf99088cba60$var$defaultProps,
        ...props
    };
    const analyticsContextData = {
        product: product,
        source: (0, $aJnVh.AnalyticsSource).PEOPLE_MENU,
        componentName: (0, $aJnVh.AnalyticsSource).PEOPLE_MENU,
        ...(0, $4USyt.packageContext)
    };
    const commonPropsInContext = {
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        subProduct: subProduct,
        userId: userId,
        isBrowseUsersEnabled: isBrowseUsersEnabled,
        isSSR: isSSR,
        testId: testId,
        tenantUrl: (0, $erMpQ.trimLastForwardSlash)(tenantUrl),
        onClickedItem: onClickedItem,
        onClickedMenuLink: onClickedMenuLink,
        invitePeopleHandlers: invitePeopleHandlers,
        onOpen: onOpen,
        onClose: onClose,
        pushRoute: pushRoute,
        _hasError: _hasError,
        addFlag: addFlag,
        isPeopleMenuOpen: false,
        isOpen: isOpen,
        teamCreateDialogProps: teamCreateDialogProps,
        shouldRenderToParent: shouldRenderToParent,
        isSectionList: isSectionList
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $59VYi.PeopleMenuContextProvider), {
        ...commonPropsInContext,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iMEBP.LazyIntlProvider), {
            fetchLanguageFile: (0, $2mhmh.fetchLanguageFile),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
                data: analyticsContextData,
                children: children
            })
        })
    });
};
var $987acf99088cba60$export$2e2bcd8739ae039 = $987acf99088cba60$var$PeopleMenuProviders;

});
parcelRegister("2mhmh", function(module, exports) {

$parcel$export(module.exports, "fetchLanguageFile", () => $b546e7ce6a72816d$export$c08b58fa4727b0d2);

var $h6CQ2 = parcelRequire("h6CQ2");
function $b546e7ce6a72816d$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return $h6CQ2.cs();
        case 'da-DK':
        case 'da':
            return $h6CQ2.da();
        case 'de-DE':
        case 'de':
            return $h6CQ2.de();
        case 'en-GB':
            return $h6CQ2.engb();
        case 'en-US':
        case 'en':
            return $h6CQ2.en();
        case 'en-ZZ':
            return $h6CQ2.enzz();
        case 'es-ES':
        case 'es':
            return $h6CQ2.es();
        case 'et-EE':
        case 'et':
            return $h6CQ2.et();
        case 'fi-FI':
        case 'fi':
            return $h6CQ2.fi();
        case 'fr-FR':
        case 'fr':
            return $h6CQ2.fr();
        case 'hu-HU':
        case 'hu':
            return $h6CQ2.hu();
        case 'is-IS':
        case 'is':
            return $h6CQ2.is();
        case 'it-IT':
        case 'it':
            return $h6CQ2.it();
        case 'ja-JP':
        case 'ja':
            return $h6CQ2.ja();
        case 'ko-KR':
        case 'ko':
            return $h6CQ2.ko();
        case 'nb-NB':
        case 'nb':
            return $h6CQ2.nb();
        case 'nl-NL':
        case 'nl':
            return $h6CQ2.nl();
        case 'pl-PL':
        case 'pl':
            return $h6CQ2.pl();
        case 'pt-PT':
        case 'pt_PT':
        case 'pt':
            return $h6CQ2.pt();
        case 'pt-BR':
        case 'pt_BR':
            return $h6CQ2.ptbr();
        case 'ro-RO':
        case 'ro':
            return $h6CQ2.ro();
        case 'ru-RU':
        case 'ru':
            return $h6CQ2.ru();
        case 'sk-SK':
        case 'sk':
            return $h6CQ2.sk();
        case 'sv-SE':
        case 'sv':
            return $h6CQ2.sv();
        case 'tr-TR':
        case 'tr':
            return $h6CQ2.tr();
        case 'th-TH':
        case 'th':
            return $h6CQ2.th();
        case 'uk-UK':
        case 'uk':
            return $h6CQ2.uk();
        case 'vi-VI':
        case 'vi':
            return $h6CQ2.vi();
        case 'zh-TW':
        case 'zh-HK':
            return $h6CQ2.zhtw();
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return $h6CQ2.zh();
    }
    return $h6CQ2.fallback();
}

});
parcelRegister("h6CQ2", function(module, exports) {

$parcel$export(module.exports, "fallback", () => $91ba7dadedf7c1b9$export$bcd1dd1f397bba12);
$parcel$export(module.exports, "cs", () => $91ba7dadedf7c1b9$export$bde1ed0f60b38f2f);
$parcel$export(module.exports, "da", () => $91ba7dadedf7c1b9$export$8c8450b83b664ba4);
$parcel$export(module.exports, "de", () => $91ba7dadedf7c1b9$export$2fa162a495d26869);
$parcel$export(module.exports, "en", () => $91ba7dadedf7c1b9$export$84584c2a98eb6753);
$parcel$export(module.exports, "engb", () => $91ba7dadedf7c1b9$export$141cd05f569bae45);
$parcel$export(module.exports, "enzz", () => $91ba7dadedf7c1b9$export$a3f288d6c3177b8a);
$parcel$export(module.exports, "es", () => $91ba7dadedf7c1b9$export$ca5e4045a55e76d2);
$parcel$export(module.exports, "et", () => $91ba7dadedf7c1b9$export$457177dcde8472be);
$parcel$export(module.exports, "fi", () => $91ba7dadedf7c1b9$export$ed5179c818622fb);
$parcel$export(module.exports, "fr", () => $91ba7dadedf7c1b9$export$acb2a88f7d552ebf);
$parcel$export(module.exports, "hu", () => $91ba7dadedf7c1b9$export$9901d21957972d53);
$parcel$export(module.exports, "is", () => $91ba7dadedf7c1b9$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "it", () => $91ba7dadedf7c1b9$export$3486a10f30cf1ee4);
$parcel$export(module.exports, "ja", () => $91ba7dadedf7c1b9$export$8c6f505e9474ce90);
$parcel$export(module.exports, "ko", () => $91ba7dadedf7c1b9$export$798cf677954c9533);
$parcel$export(module.exports, "nb", () => $91ba7dadedf7c1b9$export$38ef0e3f791a121e);
$parcel$export(module.exports, "nl", () => $91ba7dadedf7c1b9$export$9c64ee4d84d79ce1);
$parcel$export(module.exports, "pl", () => $91ba7dadedf7c1b9$export$6ea5311eda92944f);
$parcel$export(module.exports, "pt", () => $91ba7dadedf7c1b9$export$84175d5f1cb4e39d);
$parcel$export(module.exports, "ptbr", () => $91ba7dadedf7c1b9$export$82924b14976e7373);
$parcel$export(module.exports, "ro", () => $91ba7dadedf7c1b9$export$ea30ec7f37fb148d);
$parcel$export(module.exports, "ru", () => $91ba7dadedf7c1b9$export$cf48009033a0126b);
$parcel$export(module.exports, "sk", () => $91ba7dadedf7c1b9$export$d608fa5b5bfd2021);
$parcel$export(module.exports, "sv", () => $91ba7dadedf7c1b9$export$65540e5f7f6e7dce);
$parcel$export(module.exports, "tr", () => $91ba7dadedf7c1b9$export$72451b88a72ad9c2);
$parcel$export(module.exports, "th", () => $91ba7dadedf7c1b9$export$d657bc098992a431);
$parcel$export(module.exports, "uk", () => $91ba7dadedf7c1b9$export$312745a8a3013c00);
$parcel$export(module.exports, "vi", () => $91ba7dadedf7c1b9$export$e3786bf10a8abdf2);
$parcel$export(module.exports, "zh", () => $91ba7dadedf7c1b9$export$b65a7f08f2280505);
$parcel$export(module.exports, "zhtw", () => $91ba7dadedf7c1b9$export$41779e6acd26e15f);
/* istanbul ignore file */ const $91ba7dadedf7c1b9$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
        default: {}
    });

const $91ba7dadedf7c1b9$export$bde1ed0f60b38f2f = ()=>(parcelRequire("7XfGx"));

const $91ba7dadedf7c1b9$export$8c8450b83b664ba4 = ()=>(parcelRequire("aY5is"));

const $91ba7dadedf7c1b9$export$2fa162a495d26869 = ()=>(parcelRequire("f95aS"));

const $91ba7dadedf7c1b9$export$84584c2a98eb6753 = ()=>(parcelRequire("g0YTk"));

const $91ba7dadedf7c1b9$export$141cd05f569bae45 = ()=>(parcelRequire("7AsV2"));

const $91ba7dadedf7c1b9$export$a3f288d6c3177b8a = ()=>(parcelRequire("hfsjZ"));

const $91ba7dadedf7c1b9$export$ca5e4045a55e76d2 = ()=>(parcelRequire("b9CUD"));

const $91ba7dadedf7c1b9$export$457177dcde8472be = ()=>(parcelRequire("1nUJE"));

const $91ba7dadedf7c1b9$export$ed5179c818622fb = ()=>(parcelRequire("djtW4"));

const $91ba7dadedf7c1b9$export$acb2a88f7d552ebf = ()=>(parcelRequire("9FDdo"));

const $91ba7dadedf7c1b9$export$9901d21957972d53 = ()=>(parcelRequire("f741a"));

const $91ba7dadedf7c1b9$export$226b3eccf92c9ed9 = ()=>(parcelRequire("86QJP"));

const $91ba7dadedf7c1b9$export$3486a10f30cf1ee4 = ()=>(parcelRequire("5vTZj"));

const $91ba7dadedf7c1b9$export$8c6f505e9474ce90 = ()=>(parcelRequire("2PLo8"));

const $91ba7dadedf7c1b9$export$798cf677954c9533 = ()=>(parcelRequire("9wcaq"));

const $91ba7dadedf7c1b9$export$38ef0e3f791a121e = ()=>(parcelRequire("i4Gy2"));

const $91ba7dadedf7c1b9$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("46e69"));

const $91ba7dadedf7c1b9$export$6ea5311eda92944f = ()=>(parcelRequire("5rAD6"));

const $91ba7dadedf7c1b9$export$84175d5f1cb4e39d = ()=>(parcelRequire("ehEc4"));

const $91ba7dadedf7c1b9$export$82924b14976e7373 = ()=>(parcelRequire("hiy3e"));

const $91ba7dadedf7c1b9$export$ea30ec7f37fb148d = ()=>(parcelRequire("4wnzv"));

const $91ba7dadedf7c1b9$export$cf48009033a0126b = ()=>(parcelRequire("7mSAq"));

const $91ba7dadedf7c1b9$export$d608fa5b5bfd2021 = ()=>(parcelRequire("jpJOQ"));

const $91ba7dadedf7c1b9$export$65540e5f7f6e7dce = ()=>(parcelRequire("3nKZa"));

const $91ba7dadedf7c1b9$export$72451b88a72ad9c2 = ()=>(parcelRequire("aeo4w"));

const $91ba7dadedf7c1b9$export$d657bc098992a431 = ()=>(parcelRequire("evFN1"));

const $91ba7dadedf7c1b9$export$312745a8a3013c00 = ()=>(parcelRequire("3Kgnt"));

const $91ba7dadedf7c1b9$export$e3786bf10a8abdf2 = ()=>(parcelRequire("5aGCe"));

const $91ba7dadedf7c1b9$export$b65a7f08f2280505 = ()=>(parcelRequire("6oBuW"));

const $91ba7dadedf7c1b9$export$41779e6acd26e15f = ()=>(parcelRequire("6w2Bt"));

});
parcelRegister("7XfGx", function(module, exports) {

let $5caa35d4b47eaa99$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5caa35d4b47eaa99$var$load("cqrTP").then(()=>parcelRequire('kZYBr'));

});

parcelRegister("aY5is", function(module, exports) {

let $7fc39dce59820249$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7fc39dce59820249$var$load("lKWyW").then(()=>parcelRequire('4dfVD'));

});

parcelRegister("f95aS", function(module, exports) {

let $b06bb5cc3c2e6447$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b06bb5cc3c2e6447$var$load("gmUcu").then(()=>parcelRequire('aJrGo'));

});

parcelRegister("g0YTk", function(module, exports) {

let $ba8be136b08e120f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ba8be136b08e120f$var$load("1xWId").then(()=>parcelRequire('5h8br'));

});

parcelRegister("7AsV2", function(module, exports) {

let $586253e617430a5f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $586253e617430a5f$var$load("kgAik").then(()=>parcelRequire('5qYor'));

});

parcelRegister("hfsjZ", function(module, exports) {

let $c8e9ce6a63f84a56$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c8e9ce6a63f84a56$var$load("dYk9q").then(()=>parcelRequire('29nf6'));

});

parcelRegister("b9CUD", function(module, exports) {

let $81eeb82ceb575b9f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $81eeb82ceb575b9f$var$load("kBThy").then(()=>parcelRequire('3ol7V'));

});

parcelRegister("1nUJE", function(module, exports) {

let $1023f2dec81ecc5f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1023f2dec81ecc5f$var$load("1SX98").then(()=>parcelRequire('aM2eo'));

});

parcelRegister("djtW4", function(module, exports) {

let $9b144552badb310a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9b144552badb310a$var$load("aLH2u").then(()=>parcelRequire('kMgpE'));

});

parcelRegister("9FDdo", function(module, exports) {

let $70a65cb17659d61d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $70a65cb17659d61d$var$load("1BEaf").then(()=>parcelRequire('cf5Cc'));

});

parcelRegister("f741a", function(module, exports) {

let $b00aa053c84f637c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b00aa053c84f637c$var$load("1DFOb").then(()=>parcelRequire('dMw6u'));

});

parcelRegister("86QJP", function(module, exports) {

let $5e77cafa8c889f00$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5e77cafa8c889f00$var$load("4aeSx").then(()=>parcelRequire('1rOkd'));

});

parcelRegister("5vTZj", function(module, exports) {

let $403b470493fca54e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $403b470493fca54e$var$load("3OyXK").then(()=>parcelRequire('5Lzpa'));

});

parcelRegister("2PLo8", function(module, exports) {

let $21051a871355ecfb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21051a871355ecfb$var$load("blNfJ").then(()=>parcelRequire('bcOcg'));

});

parcelRegister("9wcaq", function(module, exports) {

let $6ee08a5d99f72bc0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6ee08a5d99f72bc0$var$load("1U0vr").then(()=>parcelRequire('ezzhj'));

});

parcelRegister("i4Gy2", function(module, exports) {

let $d2899adde47dce6c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d2899adde47dce6c$var$load("9aM7M").then(()=>parcelRequire('kIPzK'));

});

parcelRegister("46e69", function(module, exports) {

let $2fc2a88c2a396ecf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2fc2a88c2a396ecf$var$load("dnObq").then(()=>parcelRequire('4RP7y'));

});

parcelRegister("5rAD6", function(module, exports) {

let $3f6be33e73c83406$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3f6be33e73c83406$var$load("fFbrC").then(()=>parcelRequire('43DFy'));

});

parcelRegister("ehEc4", function(module, exports) {

let $a661d4d8c95ae67f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a661d4d8c95ae67f$var$load("7pJGx").then(()=>parcelRequire('hqDaz'));

});

parcelRegister("hiy3e", function(module, exports) {

let $c97e87edb120203a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c97e87edb120203a$var$load("dyRLq").then(()=>parcelRequire('fmx3D'));

});

parcelRegister("4wnzv", function(module, exports) {

let $34ac6f67b230a0f9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $34ac6f67b230a0f9$var$load("7IvTK").then(()=>parcelRequire('dGjHO'));

});

parcelRegister("7mSAq", function(module, exports) {

let $55d4ee3b87336ff5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $55d4ee3b87336ff5$var$load("HKJjo").then(()=>parcelRequire('ksOte'));

});

parcelRegister("jpJOQ", function(module, exports) {

let $e223e4d8861af02e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e223e4d8861af02e$var$load("34Qbm").then(()=>parcelRequire('6LMXR'));

});

parcelRegister("3nKZa", function(module, exports) {

let $2767f76e91461be6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2767f76e91461be6$var$load("jke3X").then(()=>parcelRequire('hJWhT'));

});

parcelRegister("aeo4w", function(module, exports) {

let $772de25ca8d10e90$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $772de25ca8d10e90$var$load("3Nc7d").then(()=>parcelRequire('nfKKY'));

});

parcelRegister("evFN1", function(module, exports) {

let $a904607df0605329$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a904607df0605329$var$load("bZtF0").then(()=>parcelRequire('4dmQV'));

});

parcelRegister("3Kgnt", function(module, exports) {

let $2ba25f3e2c02e738$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2ba25f3e2c02e738$var$load("9pBxJ").then(()=>parcelRequire('5EYVe'));

});

parcelRegister("5aGCe", function(module, exports) {

let $3c3ef17d13d52741$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c3ef17d13d52741$var$load("bM16t").then(()=>parcelRequire('hW6D5'));

});

parcelRegister("6oBuW", function(module, exports) {

let $4a82124b15f84d08$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4a82124b15f84d08$var$load("fESa7").then(()=>parcelRequire('1kKoV'));

});

parcelRegister("6w2Bt", function(module, exports) {

let $4be7c03a6c4626b6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4be7c03a6c4626b6$var$load("j8hoS").then(()=>parcelRequire('5A2f8'));

});





parcelRegister("eLClK", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuTriggerSSR", () => $529c48ba8e2d118c$export$7e1e2ab520ce5d59);
$parcel$export(module.exports, "default", () => $529c48ba8e2d118c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dhlon = parcelRequire("dhlon");

var $6R5uz = parcelRequire("6R5uz");

var $k1A8C = parcelRequire("k1A8C");

var $56M4r = parcelRequire("56M4r");

var $2iK1S = parcelRequire("2iK1S");

var $bkCrK = parcelRequire("bkCrK");
function $529c48ba8e2d118c$export$7e1e2ab520ce5d59({ testId: testId, peopleText: peopleText }) {
    const remoteConfig = (0, $2iK1S.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dhlon.PrimaryDropdownButton), {
        testId: `${testId}-people-primary-button-ssr`,
        children: navLabel ? navLabel : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $bkCrK.messages).teams
        })
    });
}
function $529c48ba8e2d118c$var$PeopleMenuTrigger(props) {
    const { isVisible: isVisible, isHighlighted: isHighlighted, customChevronIcon: customChevronIcon, triggerProps: triggerProps, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, isSelected: isSelected, peopleText: peopleText } = props;
    const buttonProps = (0, $gwFzn.useMemo)(()=>({
            isSelected: isSelected,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId
        }), [
        isSelected,
        onClick,
        onMouseEnter,
        testId
    ]);
    const remoteConfig = (0, $2iK1S.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    const chevron = customChevronIcon || /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: "dropdown-chevron",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($k1A8C))),
        size: "small"
    });
    const renderPrimaryDropDownButton = (0, $gwFzn.useCallback)(()=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dhlon.PrimaryDropdownButton), {
            isHighlighted: isHighlighted,
            ...buttonProps,
            ...triggerProps,
            children: navLabel || /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $bkCrK.messages).teams
            })
        });
    }, [
        buttonProps,
        isHighlighted,
        navLabel,
        triggerProps
    ]);
    if (isVisible) return renderPrimaryDropDownButton();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $56M4r.default), {
        iconAfter: chevron,
        ...triggerProps,
        ...buttonProps,
        children: navLabel || /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $bkCrK.messages).teams
        })
    });
}
var $529c48ba8e2d118c$export$2e2bcd8739ae039 = $529c48ba8e2d118c$var$PeopleMenuTrigger;

});

parcelRegister("7Ptsm", function(module, exports) {

$parcel$export(module.exports, "UsersTeamsPreFetch", () => $3e0ae8e7740a35cb$export$ffb64487c0de3976);

var $gwFzn = parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");

var $01uj3 = parcelRequire("01uj3");

var $803rE = parcelRequire("803rE");

var $4Cthy = parcelRequire("4Cthy");
function $3e0ae8e7740a35cb$export$50ca75733630fce1({ cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, createAnalyticsEvent: createAnalyticsEvent }) {
    (0, $gwFzn.useEffect)(()=>{
        (0, $4Cthy.triggerAnalyticsForPreFetchData)(createAnalyticsEvent);
        // measure duration time of fetching users and teams data
        (0, $803rE.startMeasure)('fetchingData');
    }, [
        createAnalyticsEvent
    ]);
    const { isLoading: isLoading } = (0, $01uj3.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    // stop to measure fetching data time when isLoading is finished.
    (0, $gwFzn.useEffect)(()=>{
        if (!isLoading) (0, $803rE.stopMeasure)('fetchingData', (duration, startTime)=>{
            (0, $4Cthy.triggerAnalyticsForFetchingData)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isLoading
    ]);
    return null;
}
const $3e0ae8e7740a35cb$export$ffb64487c0de3976 = (0, $1DWH0.default)()($3e0ae8e7740a35cb$export$50ca75733630fce1);

});





//# sourceMappingURL=PeopleItemWrapper.9cf400c3.js.map
